export function adicionarPontosMilhar(numero, casas=2) {
    // Valida o número
    const parsedNumber = String(numero).includes(",") ? parseFloat(String(numero).replace(",", ".")) : parseFloat(numero);

    if (isNaN(parsedNumber)) return null;

    // une a parte inteira com a parte decimal
    return parsedNumber.toLocaleString("pt-BR", { minimumFractionDigits: casas, maximumFractionDigits: casas }).replace('-',' - ');
}
